<template src="./qrcode.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    props: ["AssetId"],
    data() {
      return {
        ShowLoader: false,
        QRCodeEndpoint: Endpoints.QR.Generate + "?content=",
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicles Check View";
    },
    methods: {
      getAssetsQRCode() {
        let data = {'id' :this.AssetId, 'type':'asset'};
        var qrurl = this.QRCodeEndpoint + btoa(JSON.stringify(data));
        return qrurl;
      },
    },
  };
</script>
